import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { EstadoSolicitud, Solicitud } from '@copathy/shared';
import { api } from './api';

type Pagina = {
  datos: Solicitud[];
  total: number;
  pagina: number;
  porPagina: number;
};

export function useSolicitudes(estado: EstadoSolicitud | 'todas') {
  return useQuery({
    queryKey: ['solicitudes', estado],
    queryFn: () =>
      api.get<Pagina>(`/api/solicitudes${estado === 'todas' ? '' : `?estado=${estado}`}`),
  });
}

/**
 * Aprobar y rechazar invalidan **todas** las vistas de la cola, no solo la
 * activa: una solicitud que se aprueba desaparece de «pendientes» y aparece en
 * «aprobadas», y el contador de la otra pestaña ya no es el mismo.
 */
export function useDecidir() {
  const qc = useQueryClient();

  const invalidar = () => qc.invalidateQueries({ queryKey: ['solicitudes'] });

  const aprobar = useMutation({
    mutationFn: (id: number) => api.post<Solicitud>(`/api/solicitudes/${id}/aprobar`, {}),
    onSuccess: invalidar,
  });

  const rechazar = useMutation({
    mutationFn: (datos: { id: number; motivo: string }) =>
      api.post<Solicitud>(`/api/solicitudes/${datos.id}/rechazar`, { motivo: datos.motivo }),
    onSuccess: invalidar,
  });

  return { aprobar, rechazar };
}
